
<template>
  <div id="MakeWordCloud" class="make-word-clouds" style="display: block">
    <div v-if="comment">
        <p class="mb-0 text-center" style="font-size:30px;">ワードクラウド</p>
        <p class="pl-6 mb-0" style="font-size:15px;">ワードクラウドとは、{{$t('アイデア')}}の単語の出現頻度を文字サイズの大小で表現したチャートです。</p>
        <p class="pl-6 mb-0" style="font-size:15px;">その出現頻度に応じた大きさで単語を表示することで、全体的なテーマや内容を視覚的に捉えることができます。</p>
    </div>
    <div class="d-flex justify-center">
        <!-- <wordcloud
            :data="newCloudWords"
            nameKey="単語"
            valueKey="件数"
            :color="myColors"
            :showTooltip="true"
            :wordClick="wordClickHandler"
            :margin="{top: 15, right: 15, bottom: 15, left: 15 }"
            :rotate="{from: -0, to: 0, numOfOrientation: 1}"
            :fontSize="[30,150]"
            class="make-word-clouds"
            :style="styles"
            >
        </wordcloud> -->
        <vue-word-cloud
            v-if="newCloudWords.length!==0"
            :style="`height: ${height}; width: ${width};`"
            :words="newCloudWords"
            :color="([, weight]) => myColors[weight%4]"
            font-family="Roboto"
            :spacing="0.8"
        >
        <template v-slot="props">
            <v-tooltip top>
                <template v-slot:activator="{on}">
                    <div
                        style="cursor: pointer;"
                        v-on="on"
                        @click="onWordClick(props.word)"
                    >{{ props.text }}</div>
                </template>
                <div
                    style="text-align: left;"
                >単語：{{ props.text }}<br/>件数：{{ props.weight }}</div>
            </v-tooltip>
            </template>
        </vue-word-cloud>
        <div v-else :style="`display:flex; justify-content:center; align-items:center; height: ${height};`">
            <p style="font-size:20px;">データが存在しないか、処理中です。</p>
        </div>
    </div>
  </div>
</template>
 
<script>
import VueWordCloud from 'vuewordcloud';
import Vue from 'vue'
import VueMq from 'vue-mq'
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})
//:fontSizeMapper="fontSizeMapper"
//v-show="isShow[trueorfalse]"
//:spiral="rectangular" or "archimedian"

//cloudWordsはデータ結果を入力する



export default {
    name: 'MakeWordCloud',
    props: {
        lidid: {},
        word_dict:{},
        width:{},
        height:{},
        comment:{},
    },
    components: {
        [VueWordCloud.name]: VueWordCloud,
    },
    data() {
        return {
            isShow: {trueorfalse:false, dataShow:"0", x:385, y:268},
            myColors: ["rgb(56,141,247)","rgb(242,162,85)","rgb(213,82,85)","rgb(88,147,80)"],
            //fontSizeMapper: word => Math.log2(word.件数) * 10 / Math.log2(word.text.length),
            onWordClick: ([word, count]) => {
                // sessionStorageに、クリックした単語を保存。次の画面で検索に使用
                sessionStorage.setItem('searchWord', word);
                if (this.$mq === 'pc') {
                    this.$router.push(`/lid/${this.lidid}/idea`).catch(() => {
                        this.$emit('showIdeaList')
                    });
                } else {
                    this.$router.push(`/sp/${this.lidid}/idea`).catch(() => {
                        this.$emit('showIdeaList')
                    });
                }
            },
            newCloudWords: [],
        }
    },
    created() {
        this.wcHeight = this.height;
        //console.log(this.wcHeight)
        this.newCloudWords = [];
        for (let i in this.word_dict){
            // 記号のみは除外
            if (i.match(/[!"#$%&'\\()*+,-./:;<=>?@[\\\]^_`{|}~「」〔〕“”〈〉『』【】＆＊・（）＄＃＠。、？！｀＋￥％．〇‼]/)) continue;
            if (i.match(/[\u3000-\u303F]/)) continue;
            // 数文字のみは除外
            if (i.match(/^[0-9]+$/)) continue;
            if (i == "WS") continue;
            if (this.word_dict[i]>1){
                this.newCloudWords.push([i, this.word_dict[i]])
            }
        }
    },
    watch: {
        word_dict: function (val) {
            this.newCloudWords = [];
            for (let i in this.word_dict){
                // 記号のみは除外
                if (i.match(/[!"#$%&'\\()*+,-./:;<=>?@[\\\]^_`{|}~「」〔〕“”〈〉『』【】＆＊・（）＄＃＠。、？！｀＋￥％．〇‼]/)) continue;
                if (i.match(/[\u3000-\u303F]/)) continue;
                // 数文字のみは除外
                if (i.match(/^[0-9]+$/)) continue;
                if (i == "WS") continue;
                this.newCloudWords.push([i, this.word_dict[i]])
                // if (this.word_dict[i]>2){
                // }
            }
        }
    },
    methods:{
        mouseOverAction(){
            //console.log("You hover");
        },
        wordClickHandler(name, 件数, vm){
            //console.log(`You clicked ${name}`);
            //console.log('wordClickHandler', name, 件数, vm);
            //console.log(this.word_dict);
        }
    },
    computed: {
    // バインドするスタイルを生成
        styles () {
            return {
                '--height': this.height,
                '--width': this.width,
            }
        }
    }
}
</script>
<style scoped>
.make-word-clouds{
    --width: 100%;
    /*--height: 400px;*/
    height: var(--height);
    width: var(--width);
    left: 50;
}
/* text:hover { 
    opacity: .6 !important; 
    font-size: 300% !important;
    font-weight: bold !important;
} */
div.tooltip {
    position: absolute;
    width: 140px;
    height: 80px !important;
    padding: 8px;
    font: 18px Arial;
    line-height: 24px;
    color: black !important;
    background: whitesmoke !important;
    border: 0px;
    border-radius: 10px !important;
    pointer-events: none;
}
</style>